module.exports = "<div class=\"outer\">\n    <p>欢迎使用网页制作虚拟仿真实验平台</p>\n</div>\n"